import React from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Pivot, PivotItem, DefaultButton } from "office-ui-fabric-react";
import { noop, get } from "sites-common/utils/lodash";
import { RenderTableData } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/RenderTable";
import { doFormat } from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";

import DynamicForm from "../../components/DynamicForm";
import { storage } from "../../common1/firebase";

function toLocalISOString(date) {
  const tzOffset = date.getTimezoneOffset() * 60000;
  return new Date(date - tzOffset).toISOString().slice(0, -1);
}

const renderSingleItemForm = ({
  formFields,
  defaultValues,
  onSubmit,
  onDiscard,
  namespace,
}) => {
  const newEntryFormFields = formFields.filter((f) => f.name === "documents")[0]
    .subFormFields;
  const onSave = async (newrec, sc = noop, fc = noop) => {
    try {
      const storageRef = ref(storage, `${namespace}/${newrec?.name}`);
      const snapshot = await uploadBytes(storageRef, newrec?.document);

      const url = await getDownloadURL(snapshot.ref);
      const processedRecord = {
        ...newrec,
        date: newrec?.date
          ? toLocalISOString(newrec.date)
          : toLocalISOString(new Date()),
        document: url,
        name: newrec?.name || "",
      };
      const newValues = {
        ...defaultValues,
        documents: [processedRecord, ...defaultValues.documents],
      };

      onSubmit(newValues, sc, fc);
    } catch (error) {
      // console.error("Error uploading file:", error);
    }
  };

  return (
    <Pivot>
      {!!get(defaultValues, "documents") && defaultValues.documents.length > 0 && (
        <PivotItem
          headerText="Uploaded Documents"
          itemIcon="ThumbnailView"
          style={{ paddingTop: 20 }}
        >
          <RenderTableData
            showHeader
            colDefns={[
              [
                "Date Uploaded",
                (r) => (
                  <div>
                    {doFormat("shortdate", r?.date)} <small>{r?.sitting}</small>
                  </div>
                ),
              ],
              ["Name", "name"],
              [
                "Document Link",
                (r) =>
                  r.document ? (
                    <a
                      href={r.document}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View / Download
                    </a>
                  ) : (
                    "No file"
                  ),
              ],
            ]}
            rowData={defaultValues.documents}
          />
          <DefaultButton onClick={onDiscard} text="Close" />
        </PivotItem>
      )}
      <PivotItem headerText="Add New" itemIcon="Add">
        <DynamicForm
          namespace={namespace}
          formFields={newEntryFormFields}
          defaultValues={{}}
          onSubmit={onSave}
          onDiscard={onDiscard}
          successMessage="Document uploaded successfully"
          errorMessage="Document upload failed"
        />
      </PivotItem>
    </Pivot>
  );
};

export default renderSingleItemForm;
